import React from 'react';
import Header from '../components/Header';
import Main from '../components/Main';
import Intro from '../components/Intro';
import Team from '../components/Team';
import Menu from '../components/Menu';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import Banner2 from '../components/Banner2';
import Reservation from '../components/Reservation';
import Gallery from '../components/Gallery';
import BannerText from '../components/BannerText';
const HomeView = () => {
  return (
    <>
      <Header />
      <Main>
        <Intro />
        <BannerText />
        <Team />
        <Banner />
        <Menu />
        <Banner2 />
        <Reservation />
        <Gallery />
        <Contact />
      </Main>
      <Footer />
    </>
  );
};

export default HomeView;
